// utility file for reused general functions

export function isFromLCRP () {
  return window.location.href.indexOf('lcrp') > -1
}
